




















































































import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { Component } from "vue-property-decorator";
import store, { UserStore, RoleStore } from "@/store";
import {
  AuthenticateUserCommand,
  FindUserRolesQuery
} from "@/api/AuthenticationApiClient";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import Cookies from "js-cookie";
import router, { ROUTES } from "@/router";

@Component({
  name: "Navbar"
})
export default class Navbar extends Vue {
  private alertService = new AlertService();
  private username: string = "";
  private password: string = "";

  get currentUserName(): string | undefined {
    return UserStore.getUserName;
  }

  get isUserLoggedIn(): boolean {
    return UserStore.getJWT !== undefined;
  }

  get IsAdmin(): boolean {
    return RoleStore.isAnAdmin === true;
  }

  get IsAdvisor(): boolean {
    return RoleStore.isAnAdvisor === true;
  }

  get IsUserLoggedIn(): boolean {
    return UserStore.isUserLoggedIn;
  }

  get companyName(): string {
    return UserStore.companyName;
  }

  get companyLogo(): string {
    return UserStore.companyLogo;
  }

  get LogoutRoute(): string {
    return ROUTES.logout;
  }
}
